<template>
  <div class="thank">
    <div class="thank__overlay" @click.self="close">
      <div class="thank__content">
        <div class="thank__top">
          <img src="../assets/img/thank-icon-error.svg" alt="" class="thank__top-img">
          <p class="thank__top-title">Неуспешная регистрация!</p>
        </div>
        <p class="thank__error">{{ errorText }}</p>
        <div class="thank__btns error">
          <button @click="close" class="thank__btn">Вернуться на сайт</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error",
  props: {
    errorText: {
      type: String,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleKeydown(event) {
      if (event.key === "Escape") {
        this.close();
      }
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeydown);
  },
};
</script>
